<app-user-settings [isVerify]="true" (verified)="toLoginPage()"></app-user-settings>
